<template>
  <BaseCompletePage
    :content="getTenantsLiabilityCover"
    :hideSdnExternal="true"
    :showAllQuoteSummary="false"
    :cardTitle="
      $vuetify.breakpoint.lgAndUp
        ? 'Your Tenant’s Liability Insurance quote - ' + getMonthCoverText
        : 'Your quote'
    "
    insurancePremiumTitle="Tenants Liability premium (ex IPT)"
    annualTitle="One off payment"
  />
</template>

<script>
import BaseCompletePage from "@/views/BaseCompletePage.vue";
import { mapGetters } from "vuex";
import {
  QUESTIONS_MODULE,
  APPLICATION_MODULE,
} from "@/store/types/module-types";

export default {
  name: "CompletePage",
  components: {
    BaseCompletePage,
  },
  computed: {
    ...mapGetters(QUESTIONS_MODULE, ["getTenantsLiabilityCover"]),
    ...mapGetters(APPLICATION_MODULE, ["getMonthCoverText"]),
  },
};
</script>
